var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _g2, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 164 115"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pen_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9673FF",
    d: "m126.199 20.919-10.406 2.924a8.5 8.5 0 0 0-1.544.281l-6.279 1.764c-5.049-7.9-14.86-11.938-24.338-9.275-6.266 1.76-11.132 6.097-13.764 11.542-5.083-3.278-11.496-4.446-17.761-2.685-9.59 2.694-15.888 11.416-15.957 20.913-1.13.344-2.015.612-2.629.811-1.184.386-3.269 1.058-4.882 3.029L12.064 67.969a8.52 8.52 0 0 0-1.915 8.26 8.51 8.51 0 0 0 6.144 5.776c.349.088 6.845 1.65 13.287 3.18 3.885.924 6.993 1.654 9.24 2.176 1.355.316 2.424.559 3.166.722 1.689.374 3.024.668 4.898.141l2.856-.802c1.99 2.178 5.15 4.909 9.77 7.031 5.776 2.653 15.514 5.02 29.053 1.216l.099-.027c13.533-3.802 20.607-10.893 24.157-16.165 2.844-4.22 4.113-8.195 4.678-11.09L125.993 66a9 9 0 0 0 .578-.183l11.328-3.182c11.469-3.222 18.173-15.173 14.952-26.636l-.031-.11c-3.222-11.47-15.173-18.173-26.636-14.953z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B4FA",
    stroke: "#28B4FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.653,
    d: "M28.428 75.919 25.6 66.3l-5.338 6.736z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B4FA",
    stroke: "#28B4FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.625,
    d: "m128.546 29.247-43.16 12.125c-6.884 1.934-10.896 9.082-8.962 15.966l.032.117c1.934 6.884 9.082 10.896 15.966 8.962l43.161-12.125c6.883-1.934 10.896-9.082 8.962-15.966l-.033-.117c-1.934-6.883-9.082-10.896-15.966-8.962"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9673FF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.366,
    d: "m35.206 55.608 5.099 5.812-1.754 5.53 4.377 3.807-1.59 6.114 3.254 3.182 79.121-22.229-7.177-25.548s-81.892 23.006-81.334 23.32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.366,
    d: "m40.305 61.419 77.076-21.653M42.969 70.904l77.076-21.653"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B4FA",
    stroke: "#28B4FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.653,
    d: "M61.582 59.22c7.013-1.97 11.1-9.252 9.13-16.264-1.97-7.013-9.252-11.1-16.265-9.13-7.012 1.97-11.1 9.252-9.13 16.264 1.97 7.013 9.252 11.1 16.265 9.13"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "pen_svg__b",
    width: 26,
    height: 25,
    x: 45,
    y: 34,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.342 58.367c6.541-1.838 10.354-8.63 8.516-15.171s-8.63-10.354-15.17-8.516c-6.542 1.837-10.355 8.63-8.517 15.17 1.838 6.542 8.63 10.354 15.171 8.517"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pen_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.198 31.118s-5.374 9.278-2.91 16.565c2.466 7.288-6.531 13.388-6.531 13.388l13.993.476s2.947-6.707 1.023-12.045c-1.918-5.34 4.01-15.615 4.01-15.615l-9.598-2.765z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B4FA",
    stroke: "#28B4FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.653,
    d: "M93.832 50.16c7.013-1.97 11.1-9.251 9.13-16.264-1.97-7.012-9.252-11.1-16.264-9.13-7.013 1.97-11.1 9.252-9.13 16.265 1.97 7.012 9.251 11.1 16.264 9.13"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "pen_svg__c",
    width: 26,
    height: 25,
    x: 77,
    y: 25,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M93.592 49.306c6.541-1.837 10.354-8.63 8.516-15.17-1.837-6.542-8.63-10.355-15.17-8.517-6.542 1.838-10.355 8.63-8.517 15.17 1.838 6.542 8.63 10.355 15.171 8.517"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pen_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.448 22.058s-5.374 9.277-2.91 16.565c2.466 7.287-6.531 13.387-6.531 13.387l13.992.476s2.948-6.706 1.024-12.045c-1.918-5.34 4.011-15.615 4.011-15.615l-9.599-2.765z"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.366,
    d: "M101.289 55.766c-4.204-.125-7.764 2.844-8.531 6.837-.255.933-2.06 6.113-11.002 8.638-8.941 2.5-13.18-.983-13.89-1.645a8.43 8.43 0 0 0-10.843-1.394c-3.906 2.542-5.009 7.77-2.467 11.675.651.997 3.174 4.43 8.493 6.873 4.489 2.06 12.161 3.868 23.225.76l.043-.013.043-.012c11.063-3.108 16.672-8.647 19.431-12.743 3.263-4.853 3.634-9.1 3.671-10.29.136-4.658-3.526-8.54-8.186-8.683z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.366,
    d: "M65.625 78.664s19.181 8.47 33.115-8.461M35.203 55.608l-9.299 9.956-7.652 8.194 26.048 6.09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pen_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 40.107 142.762 0l20.946 74.558-142.762 40.107z"
  })))));
};
export default SvgPen;